import React from 'react';
import './warranty-center.css';
import { WarrantySubmitRequest } from '../../../models/warranty-center';
import Modal, { IModalChildProps } from '../../common/modal';

interface IWarrantyRequestSummaryModal extends IModalChildProps {
    warrantySubmitRequest: WarrantySubmitRequest;
    hearingAidType1: string;
    hearingAidType2: string;
    hearingAidType3: string;
    hearingAidType4: string;
    hearingAidType5: string;
    hearingAidType6: string;
    isNewNavigationEnabled: boolean;
    isNuEar: boolean;
    country: string;
}

export const WarrantyRequestSummaryModal = ({
    warrantySubmitRequest,
    hearingAidType1,
    hearingAidType2,
    hearingAidType3,
    hearingAidType4,
    hearingAidType5,
    hearingAidType6,
    isNewNavigationEnabled,
    isNuEar,
    country,
    onAccept,
    onClose,
}: IWarrantyRequestSummaryModal) => {
    return (
        <Modal>
            <>
                <div className="col-md-12">
                    <div className="pull-right">
                        {country === 'US' && (
                            <a
                                id="revrecord"
                                className="btn btn-default verticalAlignBottom"
                                href={
                                    isNewNavigationEnabled
                                        ? '/prosite/my-account/order-history'
                                        : '/my-account/account-summary'
                                }
                            >
                                Review Recent Orders
                            </a>
                        )}
                        <span className="padRight" />
                        <button
                            className="hidden-print"
                            onClick={() => window.print()}
                            style={{ paddingTop: '4px' }}
                        >
                            <i className="glyphicon glyphicon-print"></i>
                            <span>Print ...</span>
                        </button>
                    </div>
                    <h2>Your Request Has Been Submitted</h2>
                    <p>
                        <span>
                            Thank you for submitting your Warranty Request.
                        </span>
                    </p>
                    <div className="form-horizontal well">
                        <h3 className="warrantyType">
                            {warrantySubmitRequest.Action}
                        </h3>
                        {warrantySubmitRequest.Action !==
                            'Register a Standard Product' && (
                            <div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        SERIAL NUMBER 1:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.SerialNumber1
                                            }
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        SERIAL NUMBER 2:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.SerialNumber2
                                            }
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Hearing Aid Type:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {hearingAidType1}
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Patient Name:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.PatientFirstName
                                            }{' '}
                                            {
                                                warrantySubmitRequest.PatientLastName
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                        {warrantySubmitRequest.Action ===
                            'Register a Standard ProduwarrantySubmitRequestct' && (
                            <div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        SERIAL NUMBER 1:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.SerialNumber1
                                            }
                                        </p>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Item Description:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {hearingAidType1}
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        SERIAL NUMBER 2:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.SerialNumber2
                                            }
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Item Description:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {hearingAidType2}
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        SERIAL NUMBER 3:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.SerialNumber3
                                            }
                                        </p>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Item Description:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {hearingAidType3}
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        SERIAL NUMBER 4:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.SerialNumber4
                                            }
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Item Description:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {hearingAidType4}
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        SERIAL NUMBER 5:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.SerialNumber5
                                            }
                                        </p>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Item Description:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {hearingAidType5}
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        SERIAL NUMBER 6:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.SerialNumber6
                                            }
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Item Description:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {hearingAidType6}
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Patient Name:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.PatientFirstName
                                            }{' '}
                                            {
                                                warrantySubmitRequest.PatientLastName
                                            }
                                        </p>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Date Sold / Fit:(hearing aids only)')
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {warrantySubmitRequest.fitDate!.getDate()}
                                            {'/'}
                                            {warrantySubmitRequest.fitDate!.getMonth()}
                                            {'/'}
                                            {warrantySubmitRequest.fitDate!.getFullYear()}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                Bill To Account:
                            </label>
                            <div className="col-sm-8 col-md-6">
                                <p className="form-control-static">
                                    {warrantySubmitRequest.BillTo}
                                </p>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                Ship To Account:
                            </label>
                            <div className="col-sm-8 col-md-6">
                                <p className="form-control-static">
                                    {warrantySubmitRequest.ShipTo}
                                </p>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                Contact Name:
                            </label>
                            <div className="col-sm-8 col-md-6">
                                <p className="form-control-static">
                                    {warrantySubmitRequest.ContactName}
                                </p>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                Phone Number:
                            </label>
                            <div className="col-sm-8 col-md-6">
                                <p className="form-control-static">
                                    {warrantySubmitRequest.ContactPhone}
                                </p>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                Email Address:
                            </label>
                            <div className="col-sm-8 col-md-6">
                                <p className="form-control-static">
                                    {warrantySubmitRequest.EmailAddress}
                                </p>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                P.O. Number:
                            </label>
                            <div className="col-sm-8 col-md-6">
                                <p className="form-control-static"></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal-footer no-print">
                    <button
                        type="button"
                        className="btn btn-default"
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
            </>
        </Modal>
    );
};

export default WarrantyRequestSummaryModal;
